function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6b17"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6b17"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("ehtBw", function(module, exports) {

$parcel$export(module.exports, "mobileSiteHTML", () => $a6599e0179ef722e$export$226c42ce2f25a4fe);
$parcel$export(module.exports, "tabletSiteHTML", () => $a6599e0179ef722e$export$3303d8155975c5b2);

var $aASjC = parcelRequire("aASjC");

var $9ktl8 = parcelRequire("9ktl8");

var $kGueZ = parcelRequire("kGueZ");

var $imyCi = parcelRequire("imyCi");

var $3cZn2 = parcelRequire("3cZn2");

var $45yQc = parcelRequire("45yQc");
const $a6599e0179ef722e$export$226c42ce2f25a4fe = `
    <div class="logo-container">
        <img class="logo-img" src="${(0, (/*@__PURE__*/$parcel$interopDefault($aASjC)))}" alt="Pod logo" />
      </div>
      <div class="text-container">
        <h1 class="heading-primary">
          <span class="heading-primary--green">Publish Your Podcasts</span>
          <span class="heading-primary--white">Everywhere.</span>
        </h1>
        <p class="text-container__paragraph">
          Upload your audio to Pod with a single click. We'll then distribute
          your podcast to Spotify, Apple Podcasts, Google Podcasts, Pocket Casts
          and more!
        </p>
      </div>
      <div class="podcast-logos-container">
        <img
          class="podcast-logo podcast-logo--spotify"
          src="${(0, (/*@__PURE__*/$parcel$interopDefault($9ktl8)))}"
          alt="Spotify logo"
        />
        <img
          class="podcast-logo podcast-logo--apple"
          src="${(0, (/*@__PURE__*/$parcel$interopDefault($kGueZ)))}"
          alt="Apple Podcast logo"
        />
        <img
          class="podcast-logo podcast-logo--google"
          src="${(0, (/*@__PURE__*/$parcel$interopDefault($imyCi)))}"
          alt="Google Podcasts logo"
        />
        <img
          class="podcast-logo podcast-logo--pocket"
          src="${(0, (/*@__PURE__*/$parcel$interopDefault($3cZn2)))}"
          alt="Pocket Casts logo"
        />
      </div>
      <div class="form-container">
        <form class="form">
          <p class="form-error-empty hidden">Oops! Please add your email</p>
          <p class="form-error-invalid hidden">Oops! Please check your email</p>
          <p class="form-submit-success hidden">
            Thank you for submitting your email!
          </p>
          <input class="form__input" name="email" placeholder="Email address" />
          <button class="form__btn" type="submit">Request Access</button>
        </form>
      </div>
    `;
const $a6599e0179ef722e$export$3303d8155975c5b2 = `
    <div class="logo-container">
      <img class="logo-img" src="${(0, (/*@__PURE__*/$parcel$interopDefault($aASjC)))}" alt="Pod logo" />
  </div>
  <div class="text-container">
    <h1 class="heading-primary">
      <span class="heading-primary--green">Publish Your Podcasts</span>
      <span class="heading-primary--white">Everywhere.</span>
    </h1>
    <p class="text-container__paragraph">
      Upload your audio to Pod with a single click. We'll then distribute your
      podcast to Spotify, Apple Podcasts, Google Podcasts, Pocket Casts and
      more!
    </p>
    <div class="form-container">
      <form class="form">
        <div class="input-btn-container">
          <input
            class="form__input"
            name="email"
            placeholder="Email address"
          />
          <button class="form__btn" type="submit">Request Access</button>
        </div>
        <p class="form-error-empty hidden">Oops! Please add your email</p>
        <p class="form-error-invalid hidden">Oops! Please check your email</p>
        <p class="form-submit-success hidden">
          Thank you for submitting your email!
        </p>
      </form>
    </div>
    <div class="podcast-logos-container">
      <img
        class="podcast-logo podcast-logo--spotify"
        src="${(0, (/*@__PURE__*/$parcel$interopDefault($9ktl8)))}"
        alt="Spotify logo"
      />
      <img
        class="podcast-logo podcast-logo--apple"
        src="${(0, (/*@__PURE__*/$parcel$interopDefault($kGueZ)))}"
        alt="Apple Podcast logo"
      />
      <img
        class="podcast-logo podcast-logo--google"
        src="${(0, (/*@__PURE__*/$parcel$interopDefault($imyCi)))}"
        alt="Google Podcasts logo"
      />
      <img
        class="podcast-logo podcast-logo--pocket"
        src="${(0, (/*@__PURE__*/$parcel$interopDefault($3cZn2)))}"
        alt="Pocket Casts logo"
      />
    </div>
  </div>
  <div class="pattern-dots-container">
    <img
      class="pattern-dots-img"
      src="${(0, (/*@__PURE__*/$parcel$interopDefault($45yQc)))}"
      alt="Green-patterned dots"
    />
  </div>
    `;

});
parcelRequire.register("aASjC", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("aaugk"), import.meta.url).toString();

});

parcelRequire.register("9ktl8", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("fV87t"), import.meta.url).toString();

});

parcelRequire.register("kGueZ", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("is091"), import.meta.url).toString();

});

parcelRequire.register("imyCi", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("jebIi"), import.meta.url).toString();

});

parcelRequire.register("3cZn2", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("8F2yp"), import.meta.url).toString();

});

parcelRequire.register("45yQc", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("5AeS5"), import.meta.url).toString();

});


var $48a8649cf460af8f$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"g9bMM":"index.d6b37925.js","aaugk":"logo.7e0b3e6b.svg","fV87t":"spotify.ca2d110c.svg","is091":"apple-podcast.bd81cef4.svg","jebIi":"google-podcasts.b3aa9d62.svg","8F2yp":"pocket-casts.27b73834.svg","5AeS5":"bg-pattern-dots.516658aa.svg"}'));


parcelRequire("ehtBw");

//# sourceMappingURL=index.d6b37925.js.map
